import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _ProductionOrder } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectProductionOrderStateConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ProductionOrder)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            onChange(selectedId)
        }
    };

    const getLista = () => {
        instance.getProductionOrderStateConstants(null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => {
            setLista([]);
        });
    };


    return (
        <>
            <label>{label ?? "Estado"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}